/* eslint-disable max-len */
import { RSAA } from 'redux-api-middleware';

const apiUrl = process.env.REACT_APP_API_URL;

function validateArgs(config) {
  if (!config) {
    throw new Error('You must supply a config object to generateApiRequest');
  }

  if (!config.endpoint) {
    throw new Error('You must supply specify the `endpoint` property on the config object.');
  }

  if (!config.method) {
    throw new Error('You must supply specify the `method` property on the config object.');
  }

  // TODO: /signout should be a DELETE verb but it's an empty POST right now, so workaround
  if (
    !config.body &&
    (config.method !== 'GET' && config.method !== 'DELETE' && config.endpoint !== 'signout')
  ) {
    throw new Error('You must supply specify a `body` property on the config object for POST/PUT.');
  }

  if (!config.types || !Array.isArray(config.types) || config.types.length !== 3) {
    throw new Error('You must supply specify a `types` property, and it must be a 3-item array.');
  }
}

/**
 * Builds a request object to send to the API, taking care of much of the common requirements such
 * as assembling the correct endpoint, adding headers, and converting bodies to JSON.
 * Most of the arguments are the same that will exist in any redux-api-middleware request.
 *
 * @param {object} config A configuration object with the required settings. Contents are as follows:
 *                endpoint {string} The endpoint to hit (not including the domain)
 *                method {string}   One of GET, POST, PUT, DELETE (or any HTTP verb)
 *                body {object}     An object representing the body contents to send. Will be stringified
 *                types {array}     Array of the action types or handlers to use in the request.
 * @param {object} rest Optional, an object that will be appended to and can override the request object.
 * @param {boolean} isProtected Optional, true indicates the route is protected (Default: true)
 */
export default function generateApiRequest(config, rest = {}, isProtected = true) {
  validateArgs(config);

  const {
    endpoint, method, body, types,
  } = config;

  return {
    [RSAA]: {
      endpoint: `${apiUrl}/${endpoint}`,
      method,
      body: JSON.stringify(body),
      headers: (state) => {
        const headers = {
          'Content-Type': 'application/json',
        };

        if (isProtected) {
          headers['SESSION-ID'] = state.auth.sessionToken;
        }

        return headers;
      },
      types,

      ...rest,
    },
  };
}



// WEBPACK FOOTER //
// ./src/redux/apiGenerator.js